import React from 'react'
import {useSelector} from 'react-redux'
import {useTranslation} from 'react-i18next'

import Layout from '@/components/Layout'
import ContentHeader from '@/components/ContentHeader'
import GetInTouch from '@/components/GetInTouch'
import GoogleMaps from '@/components/GoogleMaps'
import WechatPopover from '@/components/WechatPopover'
import './index.less'
import './mobile.less'
import bannerImg from '@/assets/img/contactUs/banner.jpg'
import wechatImg from '@/assets/img/icon/wechat.png'
import instagramImg from '@/assets/img/icon/instagram.png'
import facebookImg from '@/assets/img/icon/facebook.png'
import pinterestImg from '@/assets/img/icon/pinterest.png'
import tiktokImg from '@/assets/img/icon/tiktok.png'
import twitterImg from '@/assets/img/icon/twitter.png'
import youtubeImg from '@/assets/img/icon/youtube.png'
import {
  FACEBOOK_LINK, IG_LINK, PINTEREST_LINK, TK_LINK, TWITTER_LINK, YT_LINK
} from "@/constants"

export default function ContactUs() {
  const {t} = useTranslation()
  const commonState = useSelector(state => state.common)
  const rootClassName = commonState.isMobile ? 'contact-us-mobile-container' : 'contact-us-container'

  return (
    <Layout isShowFooterTop={false}>
      <div className={rootClassName}>
        <ContentHeader
          className={'contact-us-header-container'}
          des={t('CONTACT US')}
          title={t('Get in Touch with Us: Contact Our Friendly Team Today!')}
          banner={bannerImg}
        />
        <div className={'contact-us-content-container'}>
          <GetInTouch
            className={'contact-us-content-left-container'}
          />
          <div className={'contact-us-content-right-container'}>
            <div className={'contact-us-content-right-working-hours-container'}>
              <div className={'contact-us-content-right-title'}>{t('WORKING HOURS')}</div>
              <div className={'contact-us-content-right-working-hours-item-container'}>
                {t('Monday - Saturday')}
                <span>: {t('9am - 5:30pm')}</span>
              </div>
              <div className={'contact-us-content-right-working-hours-item-container'}>
                {t('Sunday')}
                <span>: {t('9am - 5:30pm')}</span>
              </div>
            </div>
            <div className={'contact-us-content-right-contact-us-container'}>
              <div className={'contact-us-content-right-title'}>{t('CONTACT US')}</div>
              <div className={'contact-us-content-right-contact-us-title'}>
                1129 S Los Angeles St, Los Angeles
              </div>
              <div className={'contact-us-content-right-contact-us-des'}>
                CA 90015
              </div>
              <div className={'contact-us-content-right-contact-us-des'}>
                {t('Phone')}: 000-000-0000
              </div>
            </div>

            <div className={'contact-us-content-right-contact-us-container'}>
              <div className={'contact-us-content-right-title'}>{t('SOCIAL MEDIAS')}</div>
              <div className={'contact-us-content-right-social-medias-list'}>
                <div 
                  className={'contact-us-content-right-social-medias-item-container'}
                  onClick={() => window.open(IG_LINK)}
                >
                  <img src={instagramImg} alt="instagram" />
                </div>
                <div 
                  className={'contact-us-content-right-social-medias-item-container'}
                  onClick={() => window.open(FACEBOOK_LINK)}>
                  <img src={facebookImg} alt="facebook" />
                </div>
                <div 
                  className={'contact-us-content-right-social-medias-item-container'}
                  onClick={() => window.open(PINTEREST_LINK)}>
                  <img src={pinterestImg} alt="pinterest" />
                </div>
                <div 
                  className={'contact-us-content-right-social-medias-item-container'}
                  onClick={() => window.open(TK_LINK)}>
                  <img src={tiktokImg} alt="tiktok" />
                </div>
                <div 
                  className={'contact-us-content-right-social-medias-item-container'}
                  onClick={() => window.open(TWITTER_LINK)}>
                  <img src={twitterImg} alt="twitter" />
                </div>
                <div 
                  className={'contact-us-content-right-social-medias-item-container'}
                  onClick={() => window.open(YT_LINK)}>
                  <img src={youtubeImg} alt="youtube" />
                </div>
              </div>
            </div>
            {/* <div className={'contact-us-content-right-map-container'}>
              <GoogleMaps zoomControl={!commonState.isMobile}/>
            </div> */}
          </div>
        </div>
      </div>
    </Layout>
  )
}
